/**
 * The business portal's shell adapts by category (docs/CONCEPTS.md): a
 * restaurant gets the floor editor, a class studio gets timeModel, everyone
 * else gets the plain services flow.
 */
export type PortalMode = 'restaurant' | 'classes' | 'services';

export function modeForCategory(category: string): PortalMode {
  if (category === 'restaurant') return 'restaurant';
  if (category === 'classstudio') return 'classes';
  return 'services';
}
